import * as React from 'react';
import { Box, Grid, AppBar, Toolbar, Typography, Button, Menu, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';



export default function Contact(props) {
  return (<Typography variant="h4" gutterBottom>Contact</Typography>)
}
